'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeProvider = require('@spp/theme-provider');

var _CoreComments = require('./CoreComments');

var _CoreComments2 = _interopRequireDefault(_CoreComments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@spp/ui-core-comments')(_CoreComments2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-comments/lib/cjs/index.js
 ** module id = 595
 ** module chunks = 1
 **/